import { render, staticRenderFns } from "./EditArticle.vue?vue&type=template&id=3c3f48bc&scoped=true"
import script from "./EditArticle.vue?vue&type=script&lang=js"
export * from "./EditArticle.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c3f48bc",
  null
  
)

export default component.exports